import { render } from "./cargarArchivo.vue?vue&type=template&id=08d22439&scoped=true"
import script from "./cargarArchivo.vue?vue&type=script&lang=js"
export * from "./cargarArchivo.vue?vue&type=script&lang=js"

import "./cargarArchivo.vue?vue&type=style&index=0&id=08d22439&scoped=true&lang=css"
import "./cargarArchivo.vue?vue&type=style&index=1&id=08d22439&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d22439"]])

export default __exports__